import { Suspense } from "react";
import { useTranslation } from "react-i18next";

import { ButtonTemplate } from "components/Button/Button";
import LoadingOverlap from "components/LoadingOverlap";
import { Modal } from "components/Modal/Modal";

import ConnectModal from "./ConnectModal";

import styles from "./ConnectModal.module.scss";

type ConnectModalLoaderProps = {
  onClose: () => void;
  defaultDatabase?: string;
  defaultEngine?: string;
};

const ConnectModalLoader = (props: ConnectModalLoaderProps) => {
  const { onClose, defaultDatabase, defaultEngine } = props;
  const { t } = useTranslation();

  return (
    <Suspense
      fallback={
        <Modal
          onClose={onClose}
          title={t("connect_modal.title")}
          hideCancel
          hideFooter
          maxWidth="lg"
          primaryButton={{
            text: t("connect_modal.close"),
            template: ButtonTemplate.Ghost,
            onSubmit: event => {
              event.preventDefault();
              onClose();
            },
          }}
          classes={{
            body: styles.modalBody,
          }}
        >
          <div className={styles.root}>
            <div style={{ height: "549px" }} />
            <LoadingOverlap
              isLoading
              dimmed
            />
          </div>
        </Modal>
      }
    >
      <ConnectModal
        onClose={onClose}
        defaultDatabase={defaultDatabase}
        defaultEngine={defaultEngine}
      />
    </Suspense>
  );
};

export default ConnectModalLoader;
